import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";
import { BasePagingResponse } from "../_types";
import { GetSalesmanBonusListRequest, ISalesmanBonus } from "./types";

export const getSalesmanBonusList = async (data: GetSalesmanBonusListRequest): Promise<BasePagingResponse<ISalesmanBonus[]>> => {
    const response = await axiosInstance.post<BasePagingResponse<ISalesmanBonus[]>>(
        "/SalesmanBonus/GetBonusParameterTermList",
        data
    );
    return response.data;
};

export function useGetSalesmanBonusList() {
    return useMutation<BasePagingResponse<ISalesmanBonus[]>, Error, GetSalesmanBonusListRequest>(
        (variables) => getSalesmanBonusList(variables)
    );
}
